import React from 'react';
import { Slide, Bounce } from 'react-awesome-reveal';
import { motion } from 'framer-motion';
import AZ from '../../assets/logos/logo2.png';
import HOT from '../../assets/images/ceo.jpg';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const textVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const imageVariants = {
  hidden: { opacity: 0, rotateY: -90, scale: 0.7 },
  visible: {
    opacity: 1,
    rotateY: 0,
    scale: 1,
    transition: { duration: 1, ease: 'easeOut' },
  },
  hover: {
    scale: 1.05,
    rotateY: 5,
    transition: { duration: 0.3 },
  },
};

const MainContainer2 = () => {
  return (
    <section
      id="main-container"
      className="main-container py-5"
      style={{
        backgroundImage: 'url(images/assets/ban44.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderBottom: '10px #917232 solid',
      }}
    >
      <div className="container">
        <div className="text-center mb-4">
          <Bounce>
            <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 400 }} />
          </Bounce>
        </div>

        <motion.div
          className="row align-items-center"
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={{ once: true }}
        >
          {/* Image gauche */}
          <motion.div
            className="col-lg-5 text-center mb-4 mb-lg-0"
            variants={imageVariants}
            whileHover="hover"
          >
            <motion.img
              src={HOT}
              alt="CEO"
              className="img-fluid rounded shadow"
              loading="lazy"
              style={{ border: '8px solid #917232', borderRadius: '20px' }}
            />
          </motion.div>

          {/* Bloc texte glassmorphism */}
          <div className="col-lg-7">
            <div
              style={{
                backdropFilter: 'blur(10px)',
                background: 'rgba(20, 20, 20, 0.5)',
                borderRadius: '20px',
                padding: '30px',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                minHeight: '100%',
              }}
            >
              <Slide direction="left">
                <h1 className="mb-4" style={{ fontFamily: 'Times', color: '#fbe19a' }}>
                  <b>Administrateur Général et Associé Unique de GEKAS Security and Consulting SARL</b>
                </h1>
              </Slide>

              {[
                "En tant qu’Administrateur Général et Associé Unique de GEKAS Security and Consulting SARL, je suis fier de porter une vision claire : ",
                "faire de la sécurité un pilier du développement en République Démocratique du Congo. ",
                "GEKAS n’est pas qu’une entreprise de sécurité, c’est un partenaire de confiance, engagé à protéger les vies, les biens et les investissements. ",
                "Grâce à une équipe formée, disciplinée et dévouée, nous proposons des solutions modernes, adaptées aux défis d’aujourd’hui. ",
                "De la protection rapprochée à la surveillance de sites miniers, en passant par la sécurité résidentielle et le transport sécurisé, GEKAS s’impose comme un acteur majeur du secteur. ",
                "Notre promesse : intégrité, professionnalisme, performance. Parce que votre sécurité est notre priorité. "
              ].map((text, index) => (
                <motion.p
                  key={index}
                  className="mb-3"
                  style={{ fontSize: '20px', fontFamily: 'Times', color: '#FFF' }}
                  variants={textVariants}
                >
                  {text}
                </motion.p>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MainContainer2;
